require('./logoutModalCC.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ components
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ helpers
const { formatText } = require('core/i18n').i18n;

class LogoutModalCC extends React.Component {
    render() {
        const {closeModal, isOpen, onUserLogout} = this.props;
        const formattedMessage = formatText('logoutConfirmationModal-message');
        const formattedTitleText = formatText('logoutConfirmationModal-title');
        const formattedSignOffText = formatText('logoutConfirmationModal-signOffButton');
        const formattedStayHereText = formatText('logoutConfirmationModal-stayHereButton');
        const overlayClassName = 'logout-modal__overlay';
        return (
            <ModalCustom
                shouldCloseOnOverlayClick={false}
                isOpen={isOpen}
                overlayClassName={overlayClassName}
                onRequestClose={closeModal}
            >
                <div className="logout-modal__title">
                    {formattedTitleText}
                </div>
                <div className="logout-modal__message">
                    {formattedMessage}
                </div>
                <div className="logout-modal__footer custom-modal__footer">
                    <div className="logout-modal__buttons-wrapper">
                        <OKButton
                            onClick={closeModal}
                            modifier="secondary"
                        > {formattedStayHereText} </OKButton>
                        <OKButton
                            onClick={onUserLogout}
                        > {formattedSignOffText} </OKButton>
                    </div>
                </div>
            </ModalCustom>
        );
    }
}

LogoutModalCC.propTypes = {
    closeModal: PropTypes.func.isRequired,
    onUserLogout: PropTypes.func.isRequired,
    isOpen: PropTypes.bool
};

module.exports = LogoutModalCC;
